import { AnyFieldMeta } from '@tanstack/react-form';
import AlertCircleOutline from 'mdi-material-ui/AlertCircleOutline';

type FieldErrorsProps = {
	meta: AnyFieldMeta;
	name: string;
	hideErrors?: boolean;
};

export const FieldErrors = ({ meta, name, hideErrors }: FieldErrorsProps) => {
	if (hideErrors) return null;

	// strip out any errors that have the same message
	const uniqueErrors = [...new Set(meta.errors.map((err) => err.message))];
	if (uniqueErrors.length === 0) return null;

	return (
		<div id={`${name}-error`}>
			{uniqueErrors.map((message, index) => (
				<p key={index} className='mt-2 text-base text-error'>
					<AlertCircleOutline
						className='pr-2 mt-[-3px]'
						data-test-id='AlertCircleOutlineIcon'
						aria-hidden='true'
					/>
					{message}
				</p>
			))}
		</div>
	);
};
